"use client"
import { create } from "zustand"

type Doc = {
    docid: string;
    title: string;
    content: string;
    authorId: string;
    tags: { id: string, name: string }[];
    images: string[];
}

const initialState = {
    doc: {} as Doc,
}
type DocStore = {
    doc: Doc;
    setDoc: (doc: Doc) => void;
    clearDoc: () => void;
}

const useDocStore = create<DocStore>((set) => ({
    doc: {
        docid: "",
        title: "",
        content: "",
        authorId: "",
        tags: [],
        images: [],
    },
    setDoc: (doc: Doc) => set({ doc: { ...doc } }),
    clearDoc: () => set({ doc: initialState.doc }),
}))
export default useDocStore;